import styles from "./style.module.scss";

interface ButtonProps {
  title: string;
  icon?: JSX.Element;
  dataTestId?: string;
  children?: JSX.Element;
  onClick?: () => void;
}

export default function Button({
  icon,
  title,
  children,
  dataTestId,
  onClick,
}: ButtonProps) {
  return (
    <div
      className={styles.panelButton}
      data-testid={dataTestId}
      onClick={onClick}
    >
      {icon}
      <span>{title}</span>
      {children}
    </div>
  );
}
